import getBrowserVersionFloat from "selectors/device/getBrowserVersionFloat";
import getIsAndroid from "selectors/device/getIsAndroid";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import getIsSafari from "selectors/device/getIsSafari";
import getIsUIWebViewWithInlineVideo from "selectors/device/getIsUIWebViewWithInlineVideo";
import getOsVersionFloat from "selectors/device/getOsVersionFloat";
import { createSelector } from "reselect";

const getCanAutoplaySilentVideo = createSelector(
  getBrowserVersionFloat,
  getIsAndroid,
  getIsMobileSafari,
  getIsSafari,
  getIsUIWebViewWithInlineVideo,
  getOsVersionFloat,
  (
    browserVersionFloat,
    isAndroid,
    isMobileSafari,
    isSafari,
    isUIWebViewWithInlineVideo,
    osVersionFloat,
  ) => {
    if (!osVersionFloat) {
      return false;
    }
    if (isMobileSafari) {
      return (osVersionFloat >= 10 && isSafari) || isUIWebViewWithInlineVideo;
    }
    if (isAndroid) {
      return (
        osVersionFloat >= 5 &&
        !!browserVersionFloat &&
        browserVersionFloat >= 53
      );
    }
    if (isUIWebViewWithInlineVideo) {
      return true;
    }

    return false;
  },
);

export default getCanAutoplaySilentVideo;
